import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Form } from '../../../components';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
  },
}));

const useStyleCheckboxLabel = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1.75, 2, 1),
  },
}));

const useStyleButtons = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1.75, 2, 1),
  },
}));

const UsersFilterSection = (props) => {
  const classes = useStyles();
  const classesCheckboxLabel = useStyleCheckboxLabel();
  const classesButtons = useStyleButtons();

  return (
    <Form className={classes.form} onSubmit={props.handleSubmit} noValidate>
      <Form.TextField
        variant="outlined"
        margin="normal"
        id="email"
        label="Email Address"
        name="email"
        size="small"
        onChange={props.handleChange}
        value={props.values.email}
      />
      <Form.Checkbox
        variant="outlined"
        id="onlyActive"
        label="Only Active Users"
        name="onlyActive"
        onchange={props.handleChange}
        value={props.values.onlyActive}
        classesLabel={classesCheckboxLabel}
      />
      <Button
        classes={classesButtons}
        type="submit"
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Search
      </Button>
      <Button
        classes={classesButtons}
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={() => props.history.push('users/add')}
      >
        Create User
      </Button>
    </Form>
  );
};

UsersFilterSection.propTypes = {
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
};

export default withRouter(UsersFilterSection);
